import { render, staticRenderFns } from "./news-story.vue?vue&type=template&id=0ddc5c7e&scoped=true&"
import script from "./news-story.vue?vue&type=script&lang=js&"
export * from "./news-story.vue?vue&type=script&lang=js&"
import style0 from "./news-story.vue?vue&type=style&index=0&id=0ddc5c7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddc5c7e",
  null
  
)

export default component.exports